import { SheetJSFT } from "../../../constant";
import { useComponent, useElement, useService } from "../../../hooks";
import { useImportB2BWorkData } from "./hooks";

export const ImportB2BWorkData = () => {
  const { getLocationData } = useService("Router");
  const Button = useElement("Button");
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const Box = useComponent("Box");
  const ImportResult = useComponent("ImportResult");
  const {
    trackScrolling,
    fileSelected,
    fileImported,
    processExcel,
    handleFile,
    handleChange,
    showTable,
    tableContent,
    activeShownTotal,
    importDone,
    resultWorkList,
    excelWorkList,
  } = useImportB2BWorkData();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      {fileSelected ? (
        <>
          {fileImported ? (
            !importDone && (
              <div className="flex">
                <Button
                  type="submit"
                  className="btn btn-primary mv20"
                  onClick={processExcel}
                >
                  Import
                </Button>
                <span className="mlauto">
                  Rows Attempted: <b>{excelWorkList.length}</b>
                </span>
              </div>
            )
          ) : (
            <Button
              type="submit"
              className="btn btn-primary mv20"
              onClick={handleFile}
            >
              Parse
            </Button>
          )}
        </>
      ) : (
        <Box title="Import Daily B2b Work Data">
          <Input
            type="file"
            className="hidden form-control inputfile-1"
            id="file"
            accept={SheetJSFT}
            onChange={handleChange}
          />
          <label className="btn btn-primary" htmlFor="file">
            <i className="hi-upload-cloud"></i>
            <span>Choose a file…</span>
          </label>
        </Box>
      )}
      {showTable ? (
        <Table
          className="import-table"
          data={tableContent}
          pageSize={activeShownTotal}
        />
      ) : (
        importDone && (
          <>
            <p>All Cars imported successfully</p>
            <div className="flex">
              <Button
                className="btn btn-outline ml20"
                onClick={() => getLocationData().reload()}
              >
                Import More
              </Button>
            </div>
          </>
        )
      )}
      <ImportResult resultList={resultWorkList} excelList={excelWorkList} />
    </div>
  );
};
